<label [for]="id">{{ label }}</label>

<div class="form-field-with-postfix">
    <input [id]="id"
           [value]="value"
           [required]="required"
           [disabled]="disabled"
           maxlength="30"
           pattern="^(#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})|rgba\\(\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*\\d{1,3}\\s*,\\s*(0|1|0?\\.\\d{1,2})\\s*\\))$"
           (input)="onInput($event.target.value)"
           (blur)="onTouched(); markTouched();"
           />

    <button type="button"
            class="btn"
            (click)="toggleColorPopup($event)">
        <i class="fa-solid fa-palette"></i>
    </button>
</div>

<div class="error-message" *ngIf="required && touched && !value">
    {{ label }} is required.
</div>

<div class="error-message" *ngIf="value && touched && !value.match(
  /^(#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})|rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0?\.\d{1,2})\s*\))$/
)">
    {{ label }} must have a valid format.
</div>

<popup-component #colorPopup>
    <color-chrome [color]="pickerColor"
                  (onChangeComplete)="colorChanged($event)">
    </color-chrome>
</popup-component>
